export default "__VITE_ASSET__BwBX$Drm__"